export default {
    'localhost:5201': {
        clientName: 'hakunamatatafooddb-test',
        footerLabel: 'Hakuna Matata Manipal',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/HakunaMatata/LogoHakunaMatat.png',
        title: 'Hakuna Matata',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/HakunaMatata/LogoHakunaMatat.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Pizzas', label: 'Pizzas' },
            { key: 'Chinese Soups', label: 'Chinese Soups' },
            { key: 'Shorba', label: 'Shorba' },
            { key: 'Chinese Starters', label: 'Chinese Starters' },
            { key: 'Tandoor Starters', label: 'Tandoor Starters' },
            { key: 'Indian Starters', label: 'Indian Starters' },
            { key: 'Coastal Starters', label: 'Coastal Starters' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/restaurant_homepage/FOOD_DELIVERY_MOBILE.gif',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/restaurant_homepage/FOOD_DELIVERY.gif'
        },
        privacyPolicyLink: 'https://docs.google.com/document/d/1SvP9uoE-571V0lB80h-lpuxfr3OJK_muCR0EpOCUfC8/edit?usp=sharing',
        termsAndConditionsLink: 'https://docs.google.com/document/d/1KX4B8cNbIS9W0xlm5gyxhmO6LquCyeE2qrGE0X-YSok/edit?usp=sharing'
    },
    'www.hakunamatata-restaurant.goyaana.com': {
        clientName: 'hakunamatatafooddb-test',
        footerLabel: 'Hakuna Matata Manipal',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/HakunaMatata/LogoHakunaMatat.png',
        title: 'Hakuna Matata',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/HakunaMatata/LogoHakunaMatat.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Pizzas', label: 'Pizzas' },
            { key: 'Chinese Soups', label: 'Chinese Soups' },
            { key: 'Dessert', label: 'Dessert' },
            { key: 'Starters', label: 'Chinese Starters' },
            { key: 'Others', label: 'Others' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/restaurant_homepage/FOOD_DELIVERY_HAKUNAMATATA_MOBILE.gif',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/restaurant_homepage/FOOD_DELIVERY_HAKUNAMATATA.gif'
        },
          privacyPolicyLink: 'https://docs.google.com/document/d/1SvP9uoE-571V0lB80h-lpuxfr3OJK_muCR0EpOCUfC8/edit?usp=sharing',
        termsAndConditionsLink: 'https://docs.google.com/document/d/1KX4B8cNbIS9W0xlm5gyxhmO6LquCyeE2qrGE0X-YSok/edit?usp=sharing'
    },
    'www.basilcafemanipal-restaurant.goyaana.com': {
        clientName: 'basilcafefooddb-test',
        footerLabel: 'Basil Cafe Manipal',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/BasilCafeManipal/logo_basilcafe.png',
        title: 'Hakuna Matata',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/HakunaMatata/LogoHakunaMatat.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Indian', label: 'Indian' },
            { key: 'Burger', label: 'Burger' },
            { key: 'Fajita', label: 'Fajita' },
            { key: 'Chinese Starters', label: 'Chinese Starters' },
            { key: 'Pastas', label: 'Pastas' },
            { key: 'Quesadilla', label: 'Quesadilla' },
            { key: 'Noodles and Rice', label: 'Noodles and Rice' },
            { key: 'Malasian Soecial', label: 'Malasian Soecial' },
            { key: 'Sauce Tossed Noodles', label: 'Sauce Tossed Noodles' },
            { key: 'Coolers', label: 'Coolers' },
            { key: 'Ice-Cream', label: 'Ice-Cream' },
            { key: 'Starter', label: 'Starter' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/restaurant_homepage/FOOD_DELIVERY_BASILCAFE_MOBILE.gif',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/restaurant_homepage/FOOD_DELIVERY_BASILCAFE.gif'
        },
          privacyPolicyLink: 'https://docs.google.com/document/d/1SvP9uoE-571V0lB80h-lpuxfr3OJK_muCR0EpOCUfC8/edit?usp=sharing',
        termsAndConditionsLink: 'https://docs.google.com/document/d/1KX4B8cNbIS9W0xlm5gyxhmO6LquCyeE2qrGE0X-YSok/edit?usp=sharing'
    },
    'www.countryinnmanipal-restaurant.goyaana.com': {
        clientName: 'cismanipalfooddb-test',
        footerLabel: 'CountryInn Manipal',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/manipal/logo.png',
        title: 'Hakuna Matata',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/HakunaMatata/LogoHakunaMatat.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Exclusive Offers', label: 'Exclusive Offers' },
            { key: 'Breakfast', label: 'Breakfast' },
            { key: 'Side Orders', label: 'Side Orders' },
            { key: 'Sandwiches', label: 'Sandwiches' },
            { key: 'New Combo Special Offer', label: 'New Combo Special Offer' },
            { key: 'Salads', label: 'Salads' },
            { key: 'Starters', label: 'Starters' },
            { key: 'Soups', label: 'Soups' },
            { key: 'Main Dish', label: 'Main Dish' },
            { key: 'South Indian Main Dish', label: 'South Indian Main Dish' },
            { key: 'RHG Signture dish', label: 'RHG Signture dish' },
            { key: 'Chinese', label: 'Chinese' },
            { key: 'Continental', label: 'Continental' },
            { key: 'Rice', label: 'Rice' },
            { key: 'Roti', label: 'Roti' },
            { key: 'Healthy Food', label: 'Healthy Food' },
            { key: 'Dessert', label: 'Dessert' },
            { key: 'Munchies', label: 'Munchies' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/restaurant_homepage/FOOD_DELIVERY_COUNTRYINN_MOBILE.gif',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/restaurant_homepage/FOOD_DELIVERY_COUNTRYINN.gif'
        },
         privacyPolicyLink: 'https://docs.google.com/document/d/1SvP9uoE-571V0lB80h-lpuxfr3OJK_muCR0EpOCUfC8/edit?usp=sharing',
        termsAndConditionsLink: 'https://docs.google.com/document/d/1KX4B8cNbIS9W0xlm5gyxhmO6LquCyeE2qrGE0X-YSok/edit?usp=sharing'
    },
    'www.ecommercebeta-shopping.goyaana.com': {
        clientName: 'ecommercebetadb',
        footerLabel: 'Ecommerce ',
        logo: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/manipal/logo.png',
        title: 'Hotel Name',
        favIconUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/HakunaMatata/LogoHakunaMatat.png',
        resetPasswordUrl: '',
        menuItems: [
            { key: 'Pizzas', label: 'Pizzas' },
            { key: 'Chinese Soups', label: 'Chinese Soups' },
            { key: 'Dessert', label: 'Dessert' },
            { key: 'Starters', label: 'Chinese Starters' },
            { key: 'Others', label: 'Others' }
        ],
        landingPageImgUrl: {
            mobileImgUrl: 'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/restaurant_homepage/FOOD_DELIVERY_COUNTRYINN_MOBILE.gif',
            webImgUrl:'https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/restaurant_homepage/FOOD_DELIVERY_COUNTRYINN.gif'
        },
         privacyPolicyLink: 'https://docs.google.com/document/d/1SvP9uoE-571V0lB80h-lpuxfr3OJK_muCR0EpOCUfC8/edit?usp=sharing',
        termsAndConditionsLink: 'https://docs.google.com/document/d/1KX4B8cNbIS9W0xlm5gyxhmO6LquCyeE2qrGE0X-YSok/edit?usp=sharing'
    },
};
